import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable()
export class OptionService {
    constructor(private http: HttpClient) {}

    public getOptionList(input: any): Observable<any> {
        return this.http.get<any>(environment.BFF + "optionlist/" + input.id);
    }
    public getOptionTypes(): Observable<any> {
        return this.http.get<any>(environment.BFF + "optiontypelist");
    }
}
